module.exports = __webpack_public_path__ + "img/trainingdoc2.7e3ce472.png";